import React, {useCallback, useState} from "react";
import {Modal} from "react-bootstrap";
import {updateQNA} from "../../Wizard/_redux/wizardCrud";

export function QnaUpdateModal({ show, onHide, qna, qnaData }) {
    const [text, setText] = useState("");
    const onChange = useCallback(
        (e) => {
            setText(e.target.value)
        },
        [],
    );

    const onClick = useCallback(
        () => {
            const updateData = {...qna}
            updateData.contents = text;
            updateQNA(updateData).then(response => {
                const result = response.data;
                // console.log(result)
                if(result) {
                    onHide()
                    qnaData()
                }
            })
        },
        [qna, text, onHide, qnaData],
    );

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header >
                QNA
            </Modal.Header>
            <Modal.Body>
                질문 : <textarea className="form-control" onChange={onChange} defaultValue={qna.contents}/>
            </Modal.Body>
            <Modal.Footer>
                <button className="form-control btn-primary" onClick={onClick}>수정하기</button>
            </Modal.Footer>
        </Modal>
    )
}